import React from "react";

const lightText = "#f4f5f7";
const dimText = "#d6dae2";
const labelText = "#b2bad2";

const DataDeletionInstruction = () => (
  <main
    className="data-deletion-page"
    style={{
      maxWidth: "820px",
      margin: "0 auto",
      padding: "2rem 1rem",
      fontFamily: "Inter, sans-serif",
      color: lightText,
      background: "transparent",
    }}
  >
    <div style={{ margin: "1.2rem 0 2.5rem 0" }}>
      <a
        href="/"
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: "rgba(140,153,253,0.12)",
          color: "#8c99fd",
          fontWeight: 500,
          borderRadius: "32px",
          fontSize: "1rem",
          padding: "8px 20px 8px 14px",
          textDecoration: "none",
          border: "1px solid #283360",
          boxShadow: "0 1px 7px 0 rgba(44,54,98,0.06)",
          transition: "background 0.15s,border 0.15s",
          gap: "0.6em",
        }}
      >
        <svg width="17" height="17" viewBox="0 0 18 18" fill="none" style={{ marginRight: 6 }} xmlns="http://www.w3.org/2000/svg">
          <path d="M11.25 14.25L6.75 9.75L11.25 5.25" stroke="#8c99fd" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Back to Home
      </a>
    </div>

    <header style={{ marginBottom: "2.5rem" }}>
      <h1
        style={{
          fontSize: "2.3rem",
          fontWeight: 700,
          letterSpacing: "-0.025em",
          color: lightText,
        }}
      >
        Data Deletion Instructions
      </h1>
      <p style={{ color: dimText, fontSize: "1.1rem", marginTop: "0.5rem" }}>
        Effective Date: 24 April 2024
      </p>
      <p style={{ color: labelText, fontSize: ".97rem", marginTop: "0.7rem", lineHeight: 1.7 }}>
        This page explains how you can request deletion of your data from any devyugal ("we", "us", or "our") platform or service. The information below guides you through the (fake) process.
      </p>
    </header>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>How to Request Data Deletion</h2>
      <ul style={{ paddingLeft: "1.25rem", color: dimText, lineHeight: 1.7 }}>
        <li>
          Send an email to{" "}
          <a style={{ color: "#77aaff" }} href="mailto:yugal@devyugal.in">
            yugal@devyugal.in
          </a>{" "}
          with the subject line: <b>“Data Deletion Request”</b>.
        </li>
        <li>
          Include the following details in your message:
          <ul style={{ marginTop: "0.5rem", paddingLeft: "1.5rem" }}>
            <li>Your full name</li>
            <li>Email address used with our services</li>
            <li>Any other identifying information (if applicable)</li>
          </ul>
        </li>
        <li>
          State clearly that you want your personal data deleted from our systems.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>
        What Happens After You Request
      </h2>
      <ul style={{ paddingLeft: "1.25rem", color: dimText, lineHeight: 1.7 }}>
        <li>You'll receive a confirmation email (if this were real) acknowledging your request.</li>
        <li>We’ll (pretend to) process your request within 7 business days.</li>
        <li>
          You will receive a follow-up email once your data is deleted (or would be, on a real system).
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>
        Additional (Fake) Information
      </h2>
      <ul style={{ paddingLeft: "1.25rem", color: dimText, lineHeight: 1.7 }}>
        <li>
          Data removal covers all personal details provided directly by you.
        </li>
        <li>
          Anonymous, non-personal analytics data may be retained for statistical purposes (even in a fake system!).
        </li>
        <li>
          If you submit a deletion request, you will (theoretically) lose access to any services tied to your data.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>Questions?</h2>
      <p style={{ color: dimText, lineHeight: 1.7 }}>
        For any questions about data deletion, (pretend to) email us at{" "}
        <a style={{ color: "#77aaff" }} href="mailto:yugal@devyugal.in">
          yugal@devyugal.in
        </a>{" "}
        and our imaginary team will respond promptly.
      </p>
    </section>

    <section style={{ marginBottom: "3rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>
        Disclaimer
      </h2>
      <p style={{ color: labelText, lineHeight: 1.65 }}>
        This is a demonstration page for fake data deletion instructions. No actual user data is stored or deleted from this website. All steps and references here are for illustrative purposes only.
      </p>
    </section>

    <footer
      style={{
        color: "#a9b1c6",
        textAlign: "center",
        marginTop: "3rem",
        fontSize: "0.97rem",
      }}
    >
      <p>
        For more info, email{" "}
        <a href="mailto:yugal@devyugal.in" style={{ color: "#77aaff" }}>
          yugal@devyugal.in
        </a>
        .<br />
        © 2025 Yugal Raj Vimal · devyugal.in
      </p>
    </footer>
  </main>
);

export default DataDeletionInstruction;